/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('usedcars.subtotals', function (el) {
        var dialog = document.querySelector(el.dataset.dialog);
        var toggler = document.querySelector(el.dataset.toggler);
        var toggle = MoyaContainer.get('core.toggle').create(toggler, dialog, 'usedCarsSubtotalsToggle', {
            closeOnBodyClick: false,
        });
        MoyaContainer.set('usedcars.subtotals', toggle);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
